// SocketContext.js
import React from "react";

import { createContext, useContext, useEffect, useState } from "react";
import { io } from "socket.io-client";

const DEBUG = process.env.REACT_APP_DEBUG === "yes";

const debugLog = (...args) => {
  if (DEBUG) console.log(...args);
};

const SocketContext = createContext(null);

export const useSocket = () => useContext(SocketContext);

export const SocketProvider = ({ children }) => {
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    const backendUrl = process.env.REACT_APP_BACKEND_URL;
    if (!backendUrl) {
      debugLog("⚠️ No backend URL for socket connection. Skipping.");
      setSocket(null);
      return;
    }
    debugLog("🔄 Connecting to Socket...");
    const newSocket = io(backendUrl, {
      reconnectionAttempts: 10,
      reconnectionDelay: 3000,
      transports: ["websocket"],
    });

    newSocket.on("connect", () => {
      debugLog("✅ Connected to Socket:", newSocket.id);
    });

    newSocket.on("disconnect", (reason) => {
      console.warn("❌ Disconnected from Socket:", reason);
    });

    newSocket.on("connect_error", (error) => {
      console.error("⚠️ Socket connection error:", error);
    });

    setSocket(newSocket);

    return () => {
      debugLog("🔌 Disconnecting Socket...");
      newSocket.disconnect();
    };
  }, []);

  return (
    <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>
  );
};
